import React, { useState } from 'react';
import ReactTooltip from 'react-tooltip';
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import Tooltip from 'react-bootstrap/Tooltip';

const OnHoverTooltip = ({
    dataFor,
    labelClassNames,
    tooltipType,
    tooltipPlace,
    tooltipEffect,
    tooltipOffset,
    delay,
    children,
    isSlimmed,
}) => {
    const [isTooltipShowing, setIsTooltipShowing] = useState(false);

    if (isSlimmed === true) {
        return (
            <OverlayTrigger
                placement={tooltipPlace}
                effect={tooltipEffect}
                delay={delay}
                overlay={<Tooltip type={tooltipType}>{children[1]}</Tooltip>}>
                {children[0]}
            </OverlayTrigger>
        );
    }
    return (
        <label
            className={labelClassNames}
            data-tip
            data-for={dataFor}
            onMouseEnter={() => setIsTooltipShowing(true)}
            onMouseLeave={() => setIsTooltipShowing(false)}>
            {children[0]}
            {isTooltipShowing ? (
                <ReactTooltip id={dataFor} place={tooltipPlace} effect={tooltipEffect} offset={tooltipOffset} type={tooltipType}>
                    {children[1]}
                </ReactTooltip>
            ) : null}
        </label>
    );
};

export default OnHoverTooltip;
